export type WordmarkSize = 'sm' | 'md' | 'lg';

const SIZES: Record<WordmarkSize, string> = {
  sm: 'text-sm', // client Today title bar
  md: 'text-base', // coach top bar
  lg: 'text-xl', // sign-in and invitation cards
};

const LOGO_PX: Record<WordmarkSize, number> = { sm: 20, md: 24, lg: 32 };

export interface WordmarkProps {
  /** The instance's display name. Always a row, never a literal in source. */
  name: string;
  /** Optional override text; falls back to the display name. */
  text?: string | null;
  /** Square logo. When present it replaces the text wordmark (D11). */
  logoUrl?: string | null;
  size?: WordmarkSize;
}

/**
 * The instance's identity, shown on every client surface and on the coach's top
 * bar. Text in Inter 600 until a logo is uploaded, at which point the logo takes
 * its place — with the name still available to screen readers.
 */
export function Wordmark({ name, text, logoUrl, size = 'md' }: WordmarkProps) {
  if (logoUrl) {
    const px = LOGO_PX[size];
    return (
      <img
        src={logoUrl}
        alt={name}
        width={px}
        height={px}
        className="rounded-[--radius-control] object-cover"
        style={{ width: px, height: px }}
      />
    );
  }

  return (
    <span className={['text-ink font-semibold tracking-tight', SIZES[size]].join(' ')}>
      {text ?? name}
    </span>
  );
}
